import {post, get} from "../../../utils/request";
import {USER_SMS_CODE, USER_INFO,USER_BIND_PHONE} from '../../../utils/api';

export const getUserInfo = (params) => {
    return (dispatch) => {
        return post(USER_INFO, params)
            .then((response) => {
                return response.data;
            });
    }
};

export const sendMessageActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_SMS_CODE, params);
        return result;
    }
}

export const bindPhoneActionResult = (params) => {
    return async (dispatch) => {
        const result = await post(USER_BIND_PHONE, params);
        return result;
    }
}
